/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ModuleLevel } from './moduleLevel';

export type ModuleMetadataLevels = ModuleLevel[] | null;
